import { useState, useEffect, useRef } from "react";
import CourseEnrollment from "./CourseEnrollment";
import { Footer } from "./Footer";
import "./CourseContents.css";
import "./style.css";
import "./footer.css";

import { useParams, Navigate } from "react-router-dom";
import { courseData } from "./courseData";

const CoursePage = () => {
	const { courseId } = useParams();
	const [expandedSections, setExpandedSections] = useState({});
	const [allExpanded, setAllExpanded] = useState(false);
	const [showStickyBtn, setShowStickyBtn] = useState(false);

	const heroRef = useRef(null);
	const formRef = useRef(null);

	// Get course data based on URL param
	const course = courseData[courseId];

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [courseId]);

	// MOVE useEffect BEFORE the conditional return
	useEffect(() => {
		const handleScroll = () => {
			if (!heroRef.current || !formRef.current) return;

			const heroBottom = heroRef.current.getBoundingClientRect().bottom;
			const formTop = formRef.current.getBoundingClientRect().top;
			const windowHeight = window.innerHeight;

			const shouldShow = heroBottom < 0 && formTop > windowHeight;
			setShowStickyBtn(shouldShow);
		};

		window.addEventListener("scroll", handleScroll);
		handleScroll();

		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	// NOW check if course exists - AFTER all hooks
	if (!course) {
		return <Navigate to="/" replace />;
	}

	const {
		courseCiricullum,
		courseHeading,
		courseSubtitle,
		CourseWhatLearn,
		CourseIncludes,
		CourseReq,
		CourseDesc,
		CourseFor,
		instructorDetails,
		InstructorBio,
	} = course;

	const toggleSection = (index) => {
		setExpandedSections((prev) => ({
			...prev,
			[index]: !prev[index],
		}));
	};

	const toggleAllSections = () => {
		if (allExpanded) {
			setExpandedSections({});
			setAllExpanded(false);
		} else {
			const expanded = {};
			courseCiricullum.forEach((_, index) => {
				expanded[index] = true;
			});
			setExpandedSections(expanded);
			setAllExpanded(true);
		}
	};

	return (
		<>
			<div className="course-hero" ref={heroRef}>
				<div className="course-hero-content">
					<div className="course-hero-text">
						<h1 className="course-hero-title">{courseHeading}</h1>
						<p className="course-hero-sub-title">{courseSubtitle}</p>
						<a href="#enroll" className="course-hero-btn">
							Enroll Now
							<img src="/arrow-up.svg" alt="simplywebdev courses up icon" />
						</a>
					</div>
					<div className="course-hero-image">
						<img src="/courseHeroIll.svg" alt="Course Project Preview" />
					</div>
				</div>
			</div>

			<div className={`sticky-enroll-btn ${showStickyBtn ? "visible" : ""}`}>
				<a href="#enroll" className="course-hero-btn">
					Enroll Now
					<img src="/arrow-up.svg" alt="simplywebdev courses up icon" />
				</a>
			</div>

			<div className="page-container">
				<div className="main-content">
					<div className="content-section">
						<CourseWhatLearn />
						<CourseIncludes />

						<div className="course-content-section">
							<h2>Course content</h2>
							<div className="content-stats">
								<button className="expand-btn" onClick={toggleAllSections}>
									{allExpanded
										? "Collapse all sections"
										: "Expand all sections"}
								</button>
							</div>
							<div className="curriculum-list">
								{courseCiricullum.map((section, index) => (
									<div key={index} className="curriculum-item">
										<div
											className="section-header"
											onClick={() => toggleSection(index)}
										>
											<span className="arrow">
												{expandedSections[index] ? "▼" : "▶"}
											</span>
											<span className="section-title">{section.heading}</span>
										</div>
										{expandedSections[index] && (
											<div className="lecture-list">
												{section.contents.map((item, i) => (
													<div key={i} className="lecture-item">
														<span>{item}</span>
													</div>
												))}
											</div>
										)}
									</div>
								))}
							</div>
						</div>
						<CourseReq />
						<CourseDesc />
						<CourseFor />

						<div className="instructor-section">
							<h2>Instructor</h2>
							<div className="instructor-card">
								<img
									src={instructorDetails.src}
									alt={instructorDetails.name}
									className="instructor-avatar"
								/>
								<div className="instructor-details">
									<h3>{instructorDetails.name}</h3>
									<p className="instructor-tagline">
										{instructorDetails.tagline}
									</p>
									<InstructorBio />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div ref={formRef}>
					<CourseEnrollment />
				</div>
			</div>
			<Footer />
		</>
	);
};

export default CoursePage;
